import { useMemo, useState } from "react";
import { YAMAHA_DCODES, dcodeByHex, decodeDcode, dtcLookup } from "../lib/yamahaDiagDb";

// Live sensor table decoded from YMETER items: { "D01": "7F", ... } (hex values).
export function YamahaSensorTable({ items }) {
  const rows = useMemo(() => Object.entries(items || {}).map(([k, v]) => {
    const hex = k.replace(/^D/i, "");
    const def = dcodeByHex(hex);
    const raw = parseInt(v, 16);
    const dec = decodeDcode(def, raw);
    return { code: hex, name: def?.name || "Unknown item", value: dec.text, unit: dec.unit, raw: v, actuator: !!def?.actuator };
  }).sort((a, b) => a.code.localeCompare(b.code)), [items]);
  return (
    <div data-testid="yamaha-sensor-table" className="rounded border border-sky-800/60 bg-[#07121f] overflow-hidden">
      <div className="px-3 py-2 text-[13px] font-bold text-sky-300 uppercase border-b border-sky-900/60">Live Data (YDS D-code)</div>
      <div className="max-h-[260px] overflow-auto">
        <table className="w-full text-[13px] font-mono">
          <thead className="sticky top-0"><tr className="bg-[#06182e] text-white text-left">
            <th className="px-3 py-1.5 w-16">CODE</th><th className="px-3 py-1.5">ITEM</th><th className="px-3 py-1.5 w-28 text-right">VALUE</th><th className="px-3 py-1.5 w-20">UNIT</th><th className="px-3 py-1.5 w-16">RAW</th>
          </tr></thead>
          <tbody>
            {rows.length ? rows.map((r) => (
              <tr key={r.code} data-testid={`yamaha-sensor-${r.code}`} className="border-t border-slate-800/60 text-slate-100">
                <td className="px-3 py-1">{r.code}</td><td className="px-3 py-1 font-sans">{r.name}</td>
                <td className="px-3 py-1 text-right text-emerald-300 font-bold">{r.value}</td><td className="px-3 py-1 text-slate-400">{r.unit}</td><td className="px-3 py-1 text-slate-500">{r.raw}</td>
              </tr>
            )) : <tr><td colSpan={5} className="px-3 py-3 text-slate-400 font-sans">Belum ada data — klik YMETER (15625) lalu ikuti perintah IG.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// DTC catalog (Yamaha fault codes, Indonesian descriptions) — search by display code / P-code / name.
export function YamahaDtcCatalog() {
  const [q, setQ] = useState("");
  const list = useMemo(() => dtcLookup(q).slice(0, 200), [q]);
  return (
    <div data-testid="yamaha-dtc-catalog" className="rounded border border-sky-800/60 bg-[#07121f] overflow-hidden">
      <div className="px-3 py-2 flex items-center gap-3 border-b border-sky-900/60">
        <span className="text-[13px] font-bold text-sky-300 uppercase shrink-0">Kode Kerusakan (DTC)</span>
        <input data-testid="yamaha-dtc-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari kode (mis. 12, 1EC2) atau nama (mis. sensor)"
          className="h-8 flex-1 rounded-[3px] border border-[#6b7280] bg-[#101722] px-2 text-[13px] text-white outline-none focus:border-sky-500" />
        <span className="text-[11px] text-slate-400 shrink-0">{list.length} entri</span>
      </div>
      <div className="max-h-[260px] overflow-auto">
        <table className="w-full text-[13px]">
          <thead className="sticky top-0"><tr className="bg-[#06182e] text-white text-left">
            <th className="px-3 py-1.5 w-20">KODE</th><th className="px-3 py-1.5 w-20">P-CODE</th><th className="px-3 py-1.5">NAMA</th><th className="px-3 py-1.5">KETERANGAN</th>
          </tr></thead>
          <tbody>
            {list.map((d) => (
              <tr key={d.dtc + d.code} className="border-t border-slate-800/60 text-slate-100 align-top">
                <td className="px-3 py-1 font-mono text-amber-300 font-bold">{d.code}</td><td className="px-3 py-1 font-mono text-slate-400">{d.dtc}</td>
                <td className="px-3 py-1">{d.name}</td><td className="px-3 py-1 text-slate-300">{d.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export const YAMAHA_DCODE_COUNT = YAMAHA_DCODES.length;
